<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="area_modal_trriger">        
        <div class="area-modal u-window">
            <div class="dialog-title t-area"></div>
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="area-view">
                        <div class="area-box">
                        <p class="now" @click="call_list"><span>大区：</span>{{ now.name }}</p>
                        <ul class="area-list" v-if="listShow">
                            <li v-for="area in areas[account_type]"
                            :key = "area.id"
                            v-bind:data-aid="area.id"
                            v-bind:data-name="area.name"
                            @click="queryPlayer" v-html="area.name"></li>
                        </ul>
                        </div>
                        <div class="player-name"><span>角色：</span>{{ now.playerName }}</div>
                    </div>
                    <p class="warn"><em class="icon i-warn"></em>绑定大区后不可修改！请仔细核对参与角色。</p>
                    <div class="u-btn submit" @click="bindArea"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import GLOBAL from '@/assets/js/global.js';
//import axios from 'axios';

export default {
    name : 'area-modal',
    data : function (){
        return {
            listShow: false,
            now: {
                "id": 0,
                "name": "",
                "playerName": '',
            },
            account_type : 'pc',
            areas: {
                pc: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                }],
                wg: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                }, {
                    "id": 17,
                    "name": "铜雀台</br>(wegame1)"
                }, {
                    "id": 18,
                    "name": "凤仪亭</br>(wegame2)"
                }],
                steam: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                    "id": 21,
                    "name": "长生殿(Steam)"
                },
                ],                 
                test: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                    "id": 21,
                    "name": "长生殿(Steam)"
                }, {
                    "id": 17,
                    "name": "铜雀台</br>(wegame1)"
                }, {
                    "id": 18,
                    "name": "凤仪亭</br>(wegame2)"
                }, {
                    "id": 100,
                    "name": "TEST_1"
                }, {
                    "id": 110,
                    "name": "TEST_2"
                }],                
            },
            from : {
                '1' : 'wg',
                '2' : 'steam',
                '0' : 'pc',
            },     
        }
    },
    created (){
        this.account_type = this.from[this.from_type];
        console.log(this.from_type);
        //this.account_type = process.env.NODE_ENV == 'development' ? 'test' : this.account_type;
        //this.account_type = 'test';
    },      
    props : {
        area_modal_trriger : {
            default : false
        },
        from_type : {
            default : 0,
        }        
    },    
    methods: {
        closeModal(){
            document.body.removeEventListener('touchmove',GLOBAL.bodyScroll,{ passive: false });
            this.$emit("modal_switch", 'area_modal_trriger');
        },
        call_list (){
            this.listShow = true;
        },
        queryPlayer(e){
            this.listShow = false;
            var _s = e.target;
            var vue = this;
                vue.now.name = _s.getAttribute('data-name').replace('</br>', '');
                vue.now.id = _s.getAttribute('data-aid');
             
            this.$axios.get(GLOBAL.ajax_url_map.queryplayer, {
                params: {
                    m3AreaId : vue.now.id
                }
            })
            .then(function (response) {
                if(response.data.code === 0){
                    vue.$toast.info('查询成功');
                    vue.now.playerName = response.data.data;
                }
                else{
                    vue.$toast.info(response.data.data);
                    vue.now.playerName = '';
                }             
            })
            .catch(function (error) {
                console.log(error);
            });             

        },
        bindArea(e){
            var _s = e.target;
            var vue = this;

            if(!vue.now.playerName)return vue.$toast.info('端游未创角');
            this.$axios.post(GLOBAL.ajax_url_map.bind + '?ver=' + GLOBAL.version, GLOBAL.param({
                m3AreaId : vue.now.id
            }))
            .then(function (response) {
                if(response.data.code === 0){
                    vue.$emit("userinfo_update", response.data.data);
                    console.log(response.data.data);
                    vue.$toast.info('大区绑定成功');
                    vue.closeModal();
                }
                else{
                    vue.$toast.info(response.data.message);
                }             
            })
            .catch(function (error) {
                console.log(error);
            });   
        },
    },    
}
</script>

<style>

    .area-modal{
        margin-top : -300px;
    }

    .t-area{
        width: 2.13rem;
        height: .57rem;
        margin: 0 auto .2rem;
        background-image: url(~@/assets/images/title-area.png);
    }

    .area-modal .dialog-content{
        position: relative;
        width: 6.68rem;
        height: 4.37rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/bg-modal-area.png);
    }

    .area-modal .dialog-wrapper{
        padding: .7rem .7rem 0;
    }

    .area-view .area-box {
        position: relative;
        width: 5.25rem;
        height: .6rem;
        line-height: .6rem;
        margin: 0 auto .14rem;
        box-sizing: border-box;
        background-color: #5c280d;
        color: #eeb364;
        vertical-align: middle;
    }

    .area-box p {
        position: relative;
        padding-left: .3rem;
        line-height: .7rem;
        color: #ffc26d;
        font-size: .24rem;
    }

    .area-box .now::after {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: .45rem;
        width: .25rem;
        height: .18rem;
        background-image: url(~@/assets/images/icon-select.png);
        background-size: .25rem .18rem;
        transform: translateY(-50%);
    }

    .area-box .now span {
        padding-right: .72rem;
        color: #a4752d;
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: .62rem;
        left: 50%;
        width: 100%;
        padding: 0 .4rem 0 .4rem;
        background-color: #5c280d;
        color: #a4752d;
        font-size: .24rem;
        transform: translateX(-50%);
        z-index: 30;
        box-sizing: border-box;
    }

    .area-view .area-list li {
        display: inline-block;
        min-width: 50%;
        /* margin-bottom: .3rem; */
        text-align: center;
        box-sizing: content-box;
        border-bottom: 1px dashed #451d08;
    }

    .area-view .player-name {
        position: relative;
        width: 5.25rem;
        height: .6rem;
        line-height: .6rem;
        margin: 0 auto .2rem;
        box-sizing: border-box;
        background-color: #5c280d;
        color: #ffc26d;
        vertical-align: middle;
        font-size: .24rem;
    }

    .area-view .player-name span {
        display: inline-block;
        padding-left: .3rem;
        padding-right: .72rem;
        color: #a4752d;
    }


    .area-modal .u-btn.submit{
        width: 2.46rem;
        height: .89rem;
        margin: .27rem auto 0;
        background-image: url(~@/assets/images/btn-check.png);    
    }    

    .area-modal .u-btn.close{
        position: absolute;
        top: -.6rem;
        right: .8rem;
    }

    .area-modal .warn{
        margin-bottom: .15rem;
        line-height: 1.6;
        color: #fe2c2c;
    }

    .i-warn{
        display: inline-block;
        vertical-align: middle;
        width: .31rem;
        height: .27rem;
        margin-right: .15rem;
        background-image: url(~@/assets/images/icon-warn.png);
    }

</style>


// WEBPACK FOOTER //
// src/components/areaModal.vue